import { render, staticRenderFns } from "./transcription-reporting-panel.vue?vue&type=template&id=65d0a7b3"
import script from "./transcription-reporting-panel.vue?vue&type=script&lang=js"
export * from "./transcription-reporting-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports